/**
 * Validates the phone number input and sets the error state if invalid.
 * If the phone number is valid, it updates the value state.
 *
 * @param value - The phone number input value.
 * @param onValidatePhoneNumber - A function to validate the phone number.
 * @param setError - A function to set the error state.
 * @param setValue - A function to set the formatted phone number.
 * @returns void
 */
const validatePhoneNumber = async ({
    value,
    onValidatePhoneNumber,
    setError,
    setValue,
}: {
    value: string;
    onValidatePhoneNumber: (
        phoneNumber: string,
        onError: () => void,
        onSuccess: (number: string) => void
    ) => Promise<void>;
    setError: (error: string | null) => void;
    setValue: (value: string) => void;
}) => {
    if (value?.length > 0) {
        const trimmedPhoneNumber = value.trim();

        await onValidatePhoneNumber(
            trimmedPhoneNumber,
            () => {
                return setError('Phone number must be valid');
            },
            (number: string) => {
                setValue(number);
                setError(null);
            }
        );
    }
};

export default validatePhoneNumber;
